import { Space, Typography } from "antd";
import { useIntl } from "react-intl";
import { getTaskRejectReason } from "utils/getTaskRejectReason";
import { PageTitle } from "./PageTitle";
import { TaskStatusTag } from "./TaskStatusTag";

type Props = {
  isLoading: boolean;
  season: any;
};

export const SeasonTitle = ({ isLoading, season }: Props) => {
  const { formatMessage } = useIntl();

  const notDefined = formatMessage({ id: "notDefined" });

  return (
    <PageTitle isLoading={isLoading}>
      <Space>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {formatMessage(
            { id: "seasonPage.title" },
            {
              competitionName: season?.competitionNameLocal ?? notDefined,
              seasonName: season?.nameLocal ?? notDefined,
            }
          )}
        </Typography.Title>
        <TaskStatusTag status={season?.taskStatus} rejectReason={getTaskRejectReason(season)} />
      </Space>
    </PageTitle>
  );
};
